import React from "react";
import Header from "./components/Header";
import Content from "./pages/Content";

const App = () => {
  return (
    <div>
      <Header />
      <Content />
    </div>
  );
};

export default App;
